import { render } from "./CustomDomain.vue?vue&type=template&id=1c2fa1e2"
import script from "./CustomDomain.vue?vue&type=script&lang=js"
export * from "./CustomDomain.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.11.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__